import * as Image from './components/content-items/image';
import * as Video from './components/content-items/video';
import * as Accordion from './components/accordion';
import './components/background';
import { init as initCertificateSearch } from './components/certificateSearch.jsx';
import { init as initFileDownload } from './components/fileDownload.jsx';
import './components/forms';
import * as MediaGallery from './components/mediaGallery';
import * as Modal from './components/modal';
import './components/sidebarNav';
import * as StickyNavigation from './components/stickyNavigation';
import * as Tabs from './components/tabs';
import './components/quickOrder';

initFileDownload();
initCertificateSearch();

/** 
 * @namespace Components
 * @memberof Promega
 */
export {
    Image,
    Video,
    Accordion,
    MediaGallery,
    Modal,
    StickyNavigation,
    Tabs
};